import React from 'react';
import PropTypes from 'prop-types';

const HeadingDetailsSection = ({ heading, children }) => {
  return (
    <section className="bg-emerald-500 bg-opacity-10 shadow-md py-20">
      <div className="container mx-auto flex items-center justify-center">
        {/* Text Section */}
        <div className="text-center px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {heading}
          </h1>
          {/* Render children here */}
          {children}
        </div>
      </div>
    </section>
  );
};

// Prop validation
HeadingDetailsSection.propTypes = {
  heading: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,  // Expecting children to be passed
};

export default HeadingDetailsSection;
